export const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
});



// WEBPACK FOOTER //
// ./src/components/PaginationActionStyles.js